import type { LegalPageLocationState } from '@utils/legalBackNavigation';

/** Scroll the landing page so a section heading sits below the sticky header. */
export function scrollLandingToSectionId(id: string): void {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = prefersReduced ? 'auto' : 'smooth';

  const scrollToEl = () => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior, block: 'start' });
    }
  };

  scrollToEl();
  requestAnimationFrame(scrollToEl);
}

/**
 * Scroll landing page to an element id from router state (e.g. return from Terms/Privacy).
 */
export function scrollLandingToStateTarget(
  state: LegalPageLocationState | null | undefined
): void {
  const id = state?.scrollTo?.trim();
  if (!id) return;
  scrollLandingToSectionId(id);
}
